/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuditEventDailyCountResponse
 */
export interface AuditEventDailyCountResponse {
    /**
     * 
     * @type {Date}
     * @memberof AuditEventDailyCountResponse
     */
    date?: Date;
    /**
     * 
     * @type {any}
     * @memberof AuditEventDailyCountResponse
     */
    count?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventDailyCountResponse
     */
    failedCount?: any | null;
}

/**
 * Check if a given object implements the AuditEventDailyCountResponse interface.
 */
export function instanceOfAuditEventDailyCountResponse(value: object): value is AuditEventDailyCountResponse {
    return true;
}

export function AuditEventDailyCountResponseFromJSON(json: any): AuditEventDailyCountResponse {
    return AuditEventDailyCountResponseFromJSONTyped(json, false);
}

export function AuditEventDailyCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventDailyCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'count': json['count'] === undefined ? undefined : json['count'] === null ? null : json['count'],
        'failedCount': json['failedCount'] === undefined ? undefined : json['failedCount'] === null ? null : json['failedCount'],
    };
}

export function AuditEventDailyCountResponseToJSON(json: any): AuditEventDailyCountResponse {
    return AuditEventDailyCountResponseToJSONTyped(json, false);
}

export function AuditEventDailyCountResponseToJSONTyped(value?: AuditEventDailyCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString(),
        'count': value['count'],
        'failedCount': value['failedCount'],
    };
}

